import React, { FunctionComponent } from 'react';
import PayntWidget from '../components/common/input/PayntWidget/PayntWidget';
import { useAppSelector } from '../app/hooks';
import MainContainer from '../components/common/layout/MainContainer';

interface PaymentProps {}

const Payment: FunctionComponent<PaymentProps> = () => {
    const [profile, checkoutDetails] = useAppSelector((state) => [
        state.profile,
        state.checkout.checkoutDetails,
    ]);
    const checkoutId = checkoutDetails?.checkoutId;
    const brandId =
        profile.publicProfile?.brandId ?? profile.publicTeam?.brandId ?? 1;

    return (
        <MainContainer
            className="bg-background"
            isBackIconShown={true}
            isHeaderShown={true}
            brandId={brandId}
        >
            <div className="h-full flex-1 flex flex-col items-center pt-8 justify-center p-4 md:py-8 bg-white-500">
                <PayntWidget checkoutId={checkoutId!} brandId={brandId} />
            </div>
        </MainContainer>
    );
};

export default Payment;
